import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment/moment";
import DatePicker, {registerLocale} from "react-datepicker";
import AddressManager from "../../../../components/Address";
import StudentController from "../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
registerLocale("vi", vi);
class ModalTransSchool extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: '',
            name: this.props.name,
            showBlock: true,
            chuyenTruongDay: new Date(),
            lydoChuyenTruong: "",
            address: "",
            provinceId: 0,
            districtId: 0,
            wardId: 0
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        this.setState({
            name:  nextProps.name,
            studentId:  nextProps.id,
        })
    }
    onTransSchool = () => {
        let payload = {
            studentId: this.props.id,
            chuyenTruongDay: this.state.chuyenTruongDay,
            lydoChuyenTruong: this.state.lydoChuyenTruong,
            truongChuyenToi: this.state.truongChuyenToi,
        }
        StudentController.chuyenTruong(payload, res => {
            if (res.success) {
                toast.success("Cập nhật chuyển trường thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }


    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Cập nhật chuyển trường-Học sinh {this.state.name} </b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Ngày chuyển<span  style={{color: "red",}}>*</span></label>
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.chuyenTruongDay === '' ? null : new Date(this.state.chuyenTruongDay)}
                                        minDate={new Date()}
                                        placeholderText="Chuyển chuyển trường"
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                let value = moment(date).format("YYYY-MM-DD").toString();
                                                try {
                                                    this.setState({
                                                        chuyenTruongDay: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                        inEditing: true
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Học kỳ<span  style={{color: "red",}}>*</span></label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.state}
                                        onChange={(e) => {
                                            this.state.state = e.target.value;
                                            this.setState({
                                                state: e.target.value,
                                                inEditing: true
                                            })
                                        }}
                                    >
                                        <option value="0">Kỳ I</option>
                                        <option value="1">Kỳ II</option>
                                        <option value="2">Kỳ Hè</option>
                                    </select>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Trường<span  style={{color: "red",}}>*</span></label>
                                    <input
                                        placeholder="Nhập tên trường chuyển đến"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.truongChuyenToi}
                                        onChange={(event) => {
                                            this.setState({
                                                truongChuyenToi: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Địa chỉ chuyển đến<span  style={{color: "red",}}>*</span></label>
                                    <input
                                        placeholder="Địa chỉ chuyển đến"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.sodangbo}
                                        onChange={(event) => {
                                            this.setState({
                                                sodangbo: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Lý do chuyển</label>
                                    <textarea name="lydoChuyenTruong" id="" cols="30" rows="3"
                                              maxLength="255"
                                              className="form-control"
                                              value={this.state.lydoChuyenTruong}
                                              onChange={e => this.setState({lydoChuyenTruong: e.target.value})}/>
                                </div>
                            </div>
                        </div>


                        <div className=" align-right col-12">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.onTransSchool()}
                                >
                                        <span className='d-flex justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className='d-flex justify-content-center'>
                                            Hủy bỏ
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalTransSchool
